import {
  IconInfrastructureKid16,
  IconInfrastructureSchool16,
  IconInfrastructureHospital16,
  IconInfrastructureStore16,
} from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';
import * as React from 'react';
import { EInfrastructureIconType, IInfrastructureType } from 'shared/map-search/types/infrastructure';

import * as styles from './InfrastructureControl.css';

interface IInfrastructureControlProps {
  activeType?: number;
  types: IInfrastructureType[];
  legend?: React.ReactNode;
  onChange(infrastructureType: IInfrastructureType | null): void;
}

const ICONS_MAP: { [key: string]: React.ReactElement | null } = {
  [EInfrastructureIconType.School]: <IconInfrastructureSchool16 />,
  [EInfrastructureIconType.Nursery]: <IconInfrastructureKid16 />,
  [EInfrastructureIconType.Clinic]: <IconInfrastructureHospital16 />,
  [EInfrastructureIconType.Grocery]: <IconInfrastructureStore16 />,
  [EInfrastructureIconType.Empty]: null,
};

export const InfrastructureControl = React.forwardRef<HTMLDivElement, IInfrastructureControlProps>(
  ({ types, onChange, activeType, legend }, ref) => {
    return (
      <div className={styles['container']} ref={ref} data-name="InfrastructureControl">
        <div className={styles['buttons']}>
          {types.map(t => {
            const icon = ICONS_MAP[t.icon];

            return (
              <div
                key={t.id}
                className={classNames(styles['type'], activeType === t.id && styles['type_active'])}
                onClick={() => onChange(t)}
              >
                {icon && <div className={styles['icon']}>{icon}</div>}
                <div>{t.name}</div>
              </div>
            );
          })}
        </div>
        {legend}
        {activeType && (
          <div className={styles['reset']}>
            <button className={styles['reset-btn']} onClick={() => onChange(null)}>
              Сбросить
            </button>
          </div>
        )}
      </div>
    );
  },
);

InfrastructureControl.displayName = 'InfrastructureControl';
